export default __webpack_public_path__ + "static/republiq-efc3317a11a4ef4bcb9963403ca0a699.mp4";